import FollowupFormRouter from "Portal/FollowUpFormRouter/View";

const FollowupFormRoutes = {
  FollowupForm: FollowupFormRouter
};

export default FollowupFormRoutes;
